<template>
    <div class="col-12 your-details">
        <template v-if="scheme === 'ecoamaps'">
            <ecoamaps-your-details-component
                :profile="profile"
                :mileagePercent="mileagePercent"
                :tooltip="tooltip"
                :taxBandTooltip="taxBandTooltip"
            />
        </template>
        <template v-else-if="scheme === 'salsac'">
            <salsac-your-details-component
                :product="product"
                :profile="profile"
                :mileagePercent="mileagePercent"
                :tooltip="tooltip"
                :taxBandTooltip="taxBandTooltip"
            />
        </template>
        <template v-else-if="scheme === 'bch' && adminPortalData">
            <bch-your-details-component
                :product="product"
                :profile="profile"
                :mileagePercent="mileagePercent"
                :tooltip="tooltip"
                :taxBandTooltip="taxBandTooltip"
                :adminPortalData="adminPortalData"
            />
        </template>
        <template v-else>
            <div class="text-center mt-4">
                <LoadingIcon/>
            </div>
        </template>
    </div>
</template>

<script>

import EcoamapsYourDetailsComponent from "./your-profile/ecoamaps/your-details-component";
import SalsacYourDetailsComponent from "./your-profile/salsac/your-details-component";
import BchYourDetailsComponent from "./your-profile/bch/your-details-component";
import LoadingIcon from "./loading-icon";
import {computed} from "vue";

export default {
    name: 'your-profile-your-details-component',
    components: {
        LoadingIcon,
        BchYourDetailsComponent,
        SalsacYourDetailsComponent,
        EcoamapsYourDetailsComponent
    },

    props: [
        'mileagePercent',
        'profile',
        'product',
        'scheme',
        'tooltip',
        'taxBandTooltip',
        'adminPortalData',
    ],

    computed: {
      productId() {
        return
      }
    }
}
</script>
